<template>

    <div class="container-fluid" :style="{'padding': $mq === 'phone' ? '1rem !important' : '2rem !important'}">

        <div class="row">
            
            <div class="copyright">

                &#169; Marieke Zwart 2020

            </div>

        </div>

    </div>
  
</template>

<script>
import { EventBus } from '../events/eventbus';

export default {
    data: () => {
        return {
            text: {
                l1: "",
                l2: "",
            },
            dutchText: {
                l1: ""
            },
            englishText: {
                l1: ""
            }            
        }
    },
    created() {
        this.text = {...this.dutchText},
        EventBus.$on('language', (language) => {
            language === 'ENGLISH' ? this.text = {...this.englishText} : this.text = {...this.dutchText};
        })
    },
}
</script>

<style scoped lang="scss">

.container-fluid {
    padding: 2rem !important;
    height: 100%;
    font-size: 1.5rem;

    border-top: 1px solid currentColor; 
}

.disclaimer {
    max-width: 80%;

        @media only screen and (max-width: 700px) {
            max-width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 1rem;
            text-align: center;
    }
}

.copyright {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;


    @media only screen and (max-width: 700px) {
            align-items: center;
            justify-content: center;
            padding: 1rem;
    }
}


</style>